import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addImage, parseLink, updateLinkData, orgInitialState } from 'redux/modules/composeboxForm';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import { Spinner } from 'components';

var validator = require('validator');

import * as styles from './Composebox.scss';
var LinkPostSection = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    composeboxForm: state.composeboxForm["".concat(orgId)] || orgInitialState,
    organization: state.organization.current,
    organizationId: state.organization.current.id,
    parsingLink: state.composeboxForm.parsingLink
  };
}, {
  addImage: addImage,
  parseLink: parseLink,
  updateLinkData: updateLinkData
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(LinkPostSection, _Component);

  var _super = _createSuper(LinkPostSection);

  function LinkPostSection() {
    var _this;

    _classCallCheck(this, LinkPostSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "extractDataFromLink", function (url) {
      var orgId = _this.props.organization.id;
      return _this.props.parseLink(url, orgId);
    });

    return _this;
  }

  _createClass(LinkPostSection, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          composeboxForm = _this$props.composeboxForm,
          organizationId = _this$props.organizationId;
      return /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-7"
      }, /*#__PURE__*/React.createElement(TextField, {
        style: {
          width: '100%'
        },
        floatingLabelText: "URL",
        onChange: function onChange(e, value) {
          return _this2.props.updateLinkData('link', value, organizationId);
        },
        value: composeboxForm.linkData.link
      })), !!composeboxForm.linkData.link && validator.isURL(composeboxForm.linkData.link) && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-1",
        style: {
          marginTop: 45
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: composeboxForm.linkData.link,
        target: "_blank",
        rel: "noopener"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-external-link"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, !this.props.parsingLink ? /*#__PURE__*/React.createElement(RaisedButton, {
        style: {
          marginTop: 30
        },
        label: 'Use Link',
        onClick: function onClick() {
          return _this2.extractDataFromLink(composeboxForm.linkData.link);
        }
      }) : /*#__PURE__*/React.createElement(Spinner, null)))));
    }
  }]);

  return LinkPostSection;
}(Component)) || _class);
export { LinkPostSection as default };